import React, { useEffect, useState } from 'react';
import { Button, Modal, message } from 'antd';
import MethodForm from '../components/MethodForm';
import MethodList from '../components/MethodList';
import { createMethod, deleteMethod, fetchMethods, updateMethod } from '../services/methodApi';
import {fetchPartners} from "../services/api";
import {useToast} from "../ToastProvider";

export default function MethodPage() {
    const [methods, setMethods] = useState([]);
    const [partners, setPartners] = useState([]);
    const [editingMethod, setEditingMethod] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const { addToast } = useToast();
    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const [methodRes, partnerRes] = await Promise.all([
                fetchMethods(),
                fetchPartners()
            ]);
            setMethods(methodRes.data || []);
            setPartners(partnerRes.data || []);
        } catch (err) {
            message.error("Lỗi khi load dữ liệu");
        }
    };

    const openModal = (method = null) => {
        setEditingMethod(method);
        setModalOpen(true);
    };

    const handleSubmitMethod = async (method) => {
        try {
            if (editingMethod) {
                await updateMethod(method);
                addToast('Đã cập nhật Method thành công','success');
            } else {
                await createMethod(method);
                addToast('Thêm phương thức mới thành công','success');
            }
            setModalOpen(false);
            await loadData();
        } catch (err) {
            addToast('Lỗi khi lưu phương thức','error');
        }
    };

    const handleDelete = async (method) => {
        try {
            await deleteMethod(method.id);
            addToast('Đã xoá phương thức','success');
            await loadData();
        } catch {
            addToast('Xoá thất bại','error');
        }
    };

    return (
        <div style={{ padding: 24 }}>
            <Button type="primary" onClick={() => openModal()} style={{ marginBottom: 16 }}>Thêm phương thức</Button>

            <MethodList
                methods={methods}
                onEdit={openModal}
                onDelete={handleDelete}
            />

            <Modal
                title={editingMethod ? 'Cập nhật phương thức' : 'Thêm phương thức'}
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                footer={null}
                destroyOnHidden
                width={900}
            >
                <MethodForm
                    handleSubmitMethod={handleSubmitMethod}
                    partners={partners}
                    editingMethod={editingMethod}
                />
            </Modal>
        </div>
    );
}
